import * as Yup from 'yup'

const fastSellPaymentSchema = Yup.object().shape({
  amount: Yup.number()
    .min(50000)
    .required(
      'Nilai transfer harus lebih dari Rp.50.000,-'
    )
})

export default fastSellPaymentSchema
